import React from "react";
import style from "./index.module.scss";
import Statics, { StatusType } from "./components/Statics";
import CountDown from "./components/CountDown";
import classNames from "classnames";
import ExportBtn from "./components/ExportBtn";
import { SignInInfo, SignStatus } from "service/signIn";
import InputSearch from "components/CourseComponents/InputSearch";

interface SignInHeaderProps {
    weekTimeId: number;
    signInId: number;
    align?: "left" | "right";
    status: SignStatus;
    signInfo: SignInInfo | null;
    onStatusChange: () => void;
    onFilterStatusChange: (status: StatusType) => void;
    onFilterTextChange: (text: string) => void;
    onCountDown: () => void;

    statics: {
        courseStuCount: number;
        signInStuCount: number;
        notSingInStuCount: number;
    };
}

export default function SignInHeader({
    weekTimeId,
    signInId,
    signInfo,
    statics,
    status,
    align = "left",
    onStatusChange,
    onFilterStatusChange,
    onFilterTextChange,
    onCountDown
}: SignInHeaderProps) {
    return (
        <div
            className={classNames(
                style.root,
                align === "right" ? style.right : ""
            )}>
            <div className={style.top}>
                <Statics
                    courseStuCount={statics.courseStuCount}
                    notSingInStuCount={statics.notSingInStuCount}
                    signInStuCount={statics.signInStuCount}
                    onChange={onFilterStatusChange}
                />
                {status === SignStatus.InProgress && (
                    <CountDown
                        signInId={signInId}
                        weekTimeId={weekTimeId}
                        signInfo={signInfo}
                        onStatusChange={onStatusChange}
                        onCountDown={onCountDown}
                    />
                )}
                {status === SignStatus.Done && (
                    <ExportBtn
                        signInId={signInId}
                        percentage={signInfo?.percentage || "--"}
                        type={signInfo?.type}
                    />
                )}
            </div>

            <div className={style.search}>
                <InputSearch
                    onChange={onFilterTextChange}
                    placeholder="输入姓名、学号查看学生的签到状态"
                />
            </div>
        </div>
    );
}
